var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("b-row", { staticClass: "topInfoRow" }, [
        _c(
          "div",
          { staticClass: "card noBoxShadow col6-left" },
          [
            !_vm.filteredResults
              ? _c("div", [
                  _c("h4", { staticClass: "marginB-5" }, [
                    _vm._v(
                      _vm._s(
                        _vm.peopleinsystem
                          ? _vm.peopleinsystem.toLocaleString()
                          : 0
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Person Records")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.filteredResults
              ? _c("div", [
                  _c("h4", { staticClass: "marginB-5" }, [
                    _vm._v(
                      _vm._s(_vm.personTotalCount) +
                        " of " +
                        _vm._s(
                          _vm.peopleinsystem
                            ? _vm.peopleinsystem.toLocaleString()
                            : 0
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Person Records")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-button",
              { attrs: { variant: "primary" }, on: { click: _vm.addPerson } },
              [_vm._v("Add New Person")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card noBoxShadow col6-right" },
          [
            _c("div", [
              _c("h4", { staticClass: "marginB-5" }, [_vm._v("Search")]),
              _vm._v(" "),
              _c("p", [_vm._v("By Name, Nickname, or Case Number")])
            ]),
            _vm._v(" "),
            _c(
              "b-input-group",
              { staticClass: "searchClearInput" },
              [
                _c("b-form-input", {
                  attrs: { placeholder: "Type to Search" },
                  on: { input: _vm.handleFilterChange },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _vm._v(" "),
                _c(
                  "b-input-group-addon",
                  [
                    _c(
                      "b-btn",
                      {
                        attrs: { disabled: !_vm.filter },
                        on: { click: _vm.clearFilter }
                      },
                      [_vm._v("Clear")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dashboard-filter-row--flex" },
        [
          _c("dashboard-filters", {
            on: {
              "set-filter": _vm.onSetFilter,
              "clear-filter": _vm.onClearFilter
            }
          }),
          _vm._v(" "),
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  path: "/reviewannualdata/" + _vm.reviewYear,
                  query: _vm.$route.query
                }
              }
            },
            [
              _vm.shouldShowAnnualDataReviewBtn
                ? _c(
                    "b-button",
                    {
                      staticClass: "marginL-32",
                      attrs: { type: "button", variant: "warning", size: "md" }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "button-text dashboard-button-text" },
                        [_vm._v("Review Annual Data")]
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.finishedLoading,
                expression: "finishedLoading"
              }
            ],
            attrs: {
              "sort-compare": _vm.sortDate,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
              hover: true,
              striped: true,
              bordered: false,
              small: true,
              fixed: true,
              responsive: "sm",
              items: _vm.persons,
              fields: _vm.tableFields,
              "current-page": _vm.currentPage
            },
            on: {
              "update:sortBy": function($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function($event) {
                _vm.sortDesc = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "id",
                fn: function(item) {
                  return _c(
                    "div",
                    {},
                    [
                      _c(
                        "b-link",
                        {
                          class: { "link--inactive": item.item.inactive },
                          on: {
                            click: function($event) {
                              return _vm.goPerson(item.value)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.value) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isShared(item)
                            ? _c("span", [
                                _c("img", {
                                  attrs: {
                                    src: "/static/img/shareYes.png",
                                    height: "21",
                                    width: "21"
                                  }
                                })
                              ])
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("b-pagination", {
            attrs: {
              "total-rows": _vm.personTotalCount,
              "per-page": _vm.NUM_OF_RECORDS_PER_PAGE,
              "prev-text": "Prev",
              "next-text": "Next",
              "current-page": _vm.currentPage
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.userEUACheck()
        ? _c(
            "b-modal",
            {
              ref: "tosModal",
              staticClass: "tos-modal",
              attrs: {
                centered: "",
                id: "myModal",
                title: "Please Accept the End User Agreement Before Proceeding",
                size: "lg",
                "ok-title": "I Accept the End User Agreement",
                "cancel-title": "I Do Not Accept the End User Agreement",
                "hide-header-close": "",
                "no-close-on-backdrop": ""
              },
              on: { cancel: _vm.handleCancel, ok: _vm.handleAcceptEUA }
            },
            [_c("Tos", { attrs: { userId: _vm.$auth.user().id } })],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22ba47ca", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ba47ca","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = 1557
// module chunks = 0